<template>
  <div style="width: 100%; height: 100%" class="popup">
    <div class="w67 _h100 posi_left">
      <div class="map_popupbox w100_h75 p10_0_0_0">
        <div class="column">
          <span class="item font2">{{ detail.deviceName }}</span>
          <span class="item m0_5">{{ detail.deviceIsOnline }}</span>
        </div>
        <div class="column">
          <span class="item">{{ detail.deviceIP }}</span>
        </div>
        <div class="column">
          <span class="item">{{ detail.deviceRegionName }}</span>
        </div>
        <div class="column">
          <span class="item">在线人数{{ detail.count }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MapWifiPop",
  components: {},
  props: {
    detail: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
/* .popup {
  background-color: transparent;
  border-radius: 0px 0px;
  overflow: hidden;
  padding: 1.8rem 1.8rem;
  width: 42.5rem;
  height: 18.125rem;
  background-image: url("../../../theme-default/src/images/bg_wifi.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
} */
</style>